import React from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import Footer from "../Footer/Footer";
import Privacypolicy from "../../pages/documents/privacypolicy";
import Tnc from "../../pages/documents/termsandconditions";
import LoginPage from "../../pages/Login/LoginPage";


export const GenRoutes = ({ signedin }) => {
    return (
        <Routes>
        <Route path="/" element={<LoginPage issignedin={signedin}/>}></Route>
        <Route path="/login" element={<LoginPage issignedin={signedin}/>}></Route>
        <Route path="/privacypolicy" element={<><Privacypolicy /></>}></Route>
        <Route path="/termsandconditions" element={<><Tnc /></>}></Route>
        </Routes>
    );
};
